import { render, staticRenderFns } from "./HistoryTransferDuo.vue?vue&type=template&id=e815dcdc&scoped=true&"
import script from "./HistoryTransferDuo.vue?vue&type=script&lang=js&"
export * from "./HistoryTransferDuo.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTransferDuo.vue?vue&type=style&index=0&id=e815dcdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e815dcdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
